import {Component, OnInit, OnDestroy, Directive, AfterViewInit} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {Router} from '@angular/router';
import {NzModalService, NzNotificationService} from 'ng-zorro-antd';

import {UploaderComponent} from 'src/app/shared/uploader';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ProductsService} from 'src/app/services';
import {
  capitalizeFirstLetter,
  removeAllSpacingBetweenWords,
} from 'src/app/helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {recursiveForm} from '../../helper/recursive-form.helper';
import {
  defaultValueEcommerce,
  EcommerceExchangeDto,
  EcommerceSaveDb,
  ecommerceValue
} from './DTO/ecommerceExchange.dto';
import {ReadMoreFileComponent} from './read-more-file/read-more-file.component';
import {environment} from "../../../../../environments/environment";

declare var $: any;

@Component({
  selector: 'app-products-form',
  templateUrl: './products-form.component.html',
  styleUrls: ['./products-form.component.scss'],
})
export class ProductsFormComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    private router: Router,
    private productService: ProductsService,
    private notification: NzNotificationService,
    private sanitizer: DomSanitizer
  ) {
  }

  unsubscribe$ = new Subject<void>();
  ecommerceList: EcommerceSaveDb[];
  form: FormGroup = this.fb.group({
    images: [null],
    videos: [null],
    productName: [null, [Validators.required]],
    barcode: [null, [Validators.required]],
    categories: [null, [Validators.required]],
    price: [null, [Validators.pattern('[0-9]*')]],
    unit: [null],
    weight: [null, [Validators.pattern('[0-9.]*')]],
    height: [null, [Validators.pattern('[0-9.]*')]],
    width: [null, [Validators.pattern('[0-9.]*')]],
    length: [null, [Validators.pattern('[0-9.]*')]],
    capacity: [null, [Validators.pattern('[0-9.]*')]],
    color: [null],
    packageMethod: [null],
    packageNumber: [null, [Validators.pattern('[0-9]*')]],
    description: this.fb.group({
      image: [''],
      detail: [null],
      description: [null],
    }),
    verifyAuth: this.fb.group({
      image: [''],
      detail: [null],
      description: [null],
    }),
    businessInfo: this.fb.group({
      image: [''],
      detail: [null],
      description: [null],
    }),
  });

  packages = [{value: 'Hộp'}, {value: 'Thùng'}];
  ecommerceImages = [];

  defaultEcommerce = defaultValueEcommerce;

  ecommerceExchanges: EcommerceExchangeDto[] = [
    {exchanges: defaultValueEcommerce[0], link: 'wwecham123', price: 10000, promotion_price: 8000},
    {exchanges: defaultValueEcommerce[2], link: 'test', price: 1000, promotion_price: 800}

  ];
  imagesEcommerce = defaultValueEcommerce.map(z => z.image);
  productId: string;
  managementStatus: number;
  requestInfoStatus: number;
  reason: string;
  roleCode: string;
  categoryStr: string;
  categoryValue: any;
  delayTimer: any;
  productName = '';
  introBusiness = '';
  descriptionProduct = '';
  shortDescription = ''
  images = [];
  images2 = [];
  imagesDescription = [];
  imagesAuth = [];
  imagesBusinessInfo = [];
  descriptionImages: any = [];
  verifyAuthImages: any = [];
  businessInfoImages: any = [];
  image;
  isScroll = false;
  isRequired;
  isLoadingBtn = false;
  disable = true;
  checkLoad = 0;
  config = {
    placeholder: '',
    tabsize: 2,
    height: '250px',
    uploadImagePath: environment.uploadImageBaseUrl,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
  };
  avatar = [];
  avatarId;
  validAvatar = false;
  test;
  videoIntro: any = [];
  categories;


  ngAfterViewInit(): void {
    this.productService
      .getById(this.productId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          const lcHistoryItem = localStorage.getItem('history_item');
          let dataHistory = null;
          if (lcHistoryItem) {
            dataHistory = JSON.parse(lcHistoryItem)
            this.images = []
            localStorage.removeItem('history_item')
          }
          if (res.code === 1) {
            setTimeout(() => {
              const element = document.querySelector(`.outer__top__right__update__image__list__item`);
              element.scroll({left: 10000, behavior: 'auto'});
              const element1 = document.querySelector(`.iframe-block`);
              element1.scroll({left: 10000, behavior: 'auto'});


            }, 1000);
            $('.note-insert').append(
              '<button type="button" class="note-btn uploadImg" ><i class="note-icon-picture"></i></button>'
            );

            $('.description1 .uploadImg').on('click', () => {
              this.openUploadDialog('description-detail', '.description1 .note-editable');
            });

            $('.verifyAuth1 .uploadImg').on('click', () => {
              this.openUploadDialog('verifyAuth-detail', '.verifyAuth1 .note-editable');
            });
            $('.businessInfo1 .uploadImg').on('click', () => {
              this.openUploadDialog('businessInfo-detail', '.businessInfo1 .note-editable');
            });
            // end config summernote
            console.log(res.data);
            if (dataHistory) {
              res.data = {...dataHistory, categories: dataHistory.categoriesList}
            }
            if (res.data) {
              this.managementStatus = res.data.managementStatus;
              this.requestInfoStatus = res.data.requestInfoStatus;
              this.reason = res.data.reason;
              this.roleCode = res.data.roleCode;
              if (res.data.ecommerceList) {
                this.ecommerceList = res.data.ecommerceList.map(z => {
                  const defaultEcommerce = defaultValueEcommerce.find(q => q.key === z.id);
                  return {
                    ...z,
                    defaultEcommerce: defaultEcommerce || {key: z.id, value: 'Khác', image: ''},
                    disabled: z.id !== 5
                  };
                }).filter(z => z.id);
                console.log(this.ecommerceList);
              } else {
                this.ecommerceList = [];
              }

              const body: any = {
                managementStatus: this.managementStatus,
                roleCode: this.roleCode,
              };
              this.productService.getManagementStatus(body);
              if (res.data.images) {
                res.data.images.forEach((file) => {
                  const data = {
                    url: file.image,
                  };
                  this.images.push(data);
                });
                this.images2 = res.data.images.map((image) => image.imageId);
                this.form.get('images').setValue(this.images2);
                if (this.images2.length > 5) {
                  this.isScroll = true;
                }
              }
              // set ảnh đại diện
              if (
                res.data.mainImage && res.data.mainImage.imageId !== null
              ) {
                this.avatar = [{url: res.data.mainImage.image}];
                this.avatarId = res.data.mainImage.imageId;
              }

              if (res.data.videos) {
                this.videoIntro = res.data.videos.map((gg) =>
                  this.sanitizer.bypassSecurityTrustResourceUrl(gg)
                );
                const urlVideos = this.videoIntro.map(
                  (gg) => gg.changingThisBreaksApplicationSecurity
                );
                this.form.get('videos').setValue(urlVideos);
              }
              this.form.get('productName').setValue(res.data.productName);
              this.form.get('barcode').setValue(res.data.barcode);
              this.form.get('barcode').disable();
              this.categories = res.data.categories ? res.data.categories : [];
              if (res.data.categories) {
                let arr = [];
                arr = res.data.categories.map((data) => {
                  return data.name;
                });
                this.categoryStr = arr.join(' / ');
                let arrCategories = [];
                arrCategories = res.data.categories.map((data) => {
                  return data.id;
                });
                this.categoryValue = arrCategories;
                this.form.get('categories').setValue(arrCategories);
              }
              this.form.get('price').setValue(res.data.price);
              this.form.get('unit').setValue(res.data.unit);
              this.form.get('weight').setValue(res.data.weight);
              this.form.get('height').setValue(res.data.height);
              this.form.get('width').setValue(res.data.width);
              this.form.get('length').setValue(res.data.length);
              this.form.get('capacity').setValue(res.data.capacity);
              this.form.get('color').setValue(res.data.color);
              this.form.get('packageMethod').setValue(res.data.packageMethod);
              this.form.get('packageNumber').setValue(res.data.packageNumber);

              if (res.data.description) {
                this.form.controls.description
                  .get('description')
                  .setValue(res.data.description.description);

                this.form.controls.description
                  .get('detail')
                  .setValue(res.data.description.detail);
                if (res.data.description.image) {
                  this.imagesDescription = [{url: res.data.description.image}];
                  this.form.controls.description
                    .get('image')
                    .setValue(res.data.description.image);
                  this.descriptionImages[0] = {
                    url: res.data.description.image,
                  };
                }
              }

              if (res.data.enterpriseInfo) {
                if (res.data.enterpriseInfo.image) {
                  this.form.controls.businessInfo
                    .get('image')
                    .setValue(res.data.enterpriseInfo.image);
                  this.imagesBusinessInfo = [{
                    url: res.data.enterpriseInfo.image,
                  }];
                }
                this.form.controls.businessInfo

                  .get('description')
                  .setValue(res.data.enterpriseInfo.description);
                this.form.controls.businessInfo
                  .get('detail')
                  .setValue(res.data.enterpriseInfo.detail);
              }

              if (res.data.identificationSign) {
                this.form.controls.verifyAuth
                  .get('description')
                  .setValue(res.data.identificationSign.description);
                this.form.controls.verifyAuth
                  .get('detail')
                  .setValue(res.data.identificationSign.detail);
                if (res.data.identificationSign.image) {
                  this.form.controls.verifyAuth
                    .get('image')
                    .setValue(res.data.identificationSign.image);
                  this.imagesAuth = [{
                    url: res.data.identificationSign.image,
                  }];
                }
              }
            }
            return;
          }
          if (res.code !== 1) {
            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            return;
          }
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
        }
      );

    // document.querySelector<HTMLElement>('#list_image').children[0]
  }

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(type, title, content);
  }

  ngOnInit() {
    this.productId = window.location.href.split('/')[5];
    const lcHistoryItem = localStorage.getItem('history_item');
    if (lcHistoryItem) {
      this.getHistoryChange(lcHistoryItem);
      return;
    }
  }

  filter(data) {
    this.defaultEcommerce = defaultValueEcommerce.filter(z => z.key !== data);
  }

  removeEcommerce(index) {
    this.ecommerceList.splice(index, 1);
  }

  selectEcommerce(data, index) {
    console.log('data', data);
    this.ecommerceList[index].defaultEcommerce = this.defaultEcommerce.filter(z => z.key == data)[0];
    this.setValue(index, data);

  }

  addView() {
    const oldValue = this.ecommerceList[this.ecommerceList.length - 1];
    console.log('oldValue', oldValue);
    console.log('!oldValue ||  oldValue.link', !oldValue || oldValue.link);
    if (!oldValue || oldValue.link) {
      const ecommerceExchange = new EcommerceSaveDb();
      this.ecommerceList.push(ecommerceExchange);
    } else {
      this.openMessage('warning', 'Cảnh báo', `Vui lòng cập nhật đủ thông tin cấu hình link bán hàng`);

    }

  }

  deleteImage() {
    this.avatar[0].url = '';
    this.avatarId = '';
  }

  customButton(context) {
    const ui = $.summernote.ui;
    const button = ui.button({
      contents: '<i class="note-icon-magic"></i> Hello',
      tooltip: 'Custom button',
      container: '.note-editor',
      className: 'note-btn',
      click: () => {
        context.invoke('editor.insertText', 'Hello from test btn!!!');
      }
    });
    return button.render();
  }

  setValue(index, data?) {
    const link = (document.querySelector('#link' + index) as HTMLInputElement).value.trim();
    if (data) {
      this.ecommerceList[index].disabled = data !== 5;
    }
    let price = (document.querySelector('#price' + index) as HTMLInputElement).value;
    let promotionPrice = (document.querySelector('#promotion_price' + index) as HTMLInputElement).value;
    if (+price < 1) {
      price = '0';
    }
    if (+promotionPrice < 1) {
      promotionPrice = '0';
    }
    this.ecommerceList[index] = {...this.ecommerceList[index], link, promotion_price: +promotionPrice, price: +price};
    console.log('  this.ecommerceList==>', this.ecommerceList);
  }

  getHistoryChange(_item: any) {
    const item = JSON.parse(_item);
    this.managementStatus = item.managementStatus;
    this.requestInfoStatus = item.requestInfoStatus;
    this.reason = item.reason;
    this.roleCode = item.roleCode;
    const body: any = {
      managementStatus: this.managementStatus,
      roleCode: this.roleCode,
    };
    this.productService.getManagementStatus(body);
    if (
      item.mainImage &&
      item.mainImage.image !== null &&
      item.mainImage.imageId !== null
    ) {
      this.avatar = [{url: item.mainImage.image}];
      this.avatarId = item.mainImage.imageId;
    }

    if (item.videos) {
      this.videoIntro = item.videos.map((gg) =>
        this.sanitizer.bypassSecurityTrustResourceUrl(gg)
      );
      const urlVideos = this.videoIntro.map(
        (gg) => gg.changingThisBreaksApplicationSecurity
      );
      this.form.get('videos').setValue(urlVideos);
    }
    if (item.images) {
      item.images.forEach((file) => {
        const data = {
          url: file.image,
        };
        this.images.push(data);
      });
      this.images2 = item.images.map((image) => image.imageId);
      this.form.get('images').setValue(this.images2);
      if (this.images2.length > 5) {
        this.isScroll = true;
      }
    }
    this.form.get('productName').setValue(item.productName);
    this.form.get('barcode').setValue(item.barcode);
    this.form.get('barcode').disable();
    if (item.categoriesList) {
      let arr = [];
      arr = item.categoriesList.map((data) => {
        return data.name;
      });
      this.categoryStr = arr.join(' / ');
      let arrCategories = [];
      arrCategories = item.categoriesList.map((data) => {
        return data.id;
      });
      this.categoryValue = arrCategories;
      this.form.get('categories').setValue(arrCategories);
    }
    this.form.get('price').setValue(item.price);
    this.form.get('unit').setValue(item.unit);
    this.form.get('weight').setValue(item.weight);
    this.form.get('height').setValue(item.height);
    this.form.get('width').setValue(item.width);
    this.form.get('length').setValue(item.length);
    this.form.get('capacity').setValue(item.capacity);
    this.form.get('color').setValue(item.color);

    if (item.description) {
      this.form.controls.description
        .get('description')
        .setValue(item.description.description);

      this.form.controls.description
        .get('detail')
        .setValue(item.description.detail);
      if (item.description.image) {
        this.form.controls.description
          .get('image')
          .setValue(item.description.image);
        this.descriptionImages[0] = {
          url: item.description.image,
        };
      }
    }

    if (item.enterpriseInfo) {
      if (item.enterpriseInfo.image) {
        this.form.controls.businessInfo
          .get('image')
          .setValue(item.enterpriseInfo.image);
        this.businessInfoImages[0] = {
          url: item.enterpriseInfo.image,
        };
      }
      this.form.controls.businessInfo
        .get('description')
        .setValue(item.enterpriseInfo.description);
      this.form.controls.businessInfo
        .get('detail')
        .setValue(item.enterpriseInfo.detail);
    }

    if (item.identificationSign) {
      this.form.controls.verifyAuth
        .get('description')
        .setValue(item.identificationSign.description);
      this.form.controls.verifyAuth
        .get('detail')
        .setValue(item.identificationSign.detail);
      if (item.identificationSign.image) {
        this.form.controls.verifyAuth
          .get('image')
          .setValue(item.identificationSign.image);
        this.verifyAuthImages[0] = {
          url: item.identificationSign.image,
        };
      }
    }
  }

  openUploadDialog(field: string, elementFill?: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';
    let multiple = true;
    if (field === 'avatar' || field === 'description' || field === 'verifyAuth' || field === 'businessInfo') {
      multiple = false;
    }
    const modal = this.modal.create({
      nzTitle: `Tải ảnh lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        console.log('123123', changeParam);
        if (changeParam.type === 'success') {
          if (field === 'images') {
            this.images.push({url: changeParam.file.response.url});
            this.images2.push(changeParam.file.response.url);
            this.form
              .get('images')
              .setValue(this.images2);
            setTimeout(() => {
              const element = document.querySelector(`.outer__top__right__update__image__list__item`);
              element.scroll({left: 10000, behavior: 'auto'});
            }, 500);

            this.form.get(field).updateValueAndValidity();
            if (this.form.value.images.length > 5) {
              this.isScroll = true;
            }
          }
          const images = changeParam.file.response.url;
          if (field === 'description-detail' || field === 'verifyAuth-detail' || field === 'businessInfo-detail') {
            $(elementFill).append(`<a href="${images}" target="_blank"><img src="${images}" alt=""  ></a>`)
            let value = this.form.get(field.slice(0, -7)).value.detail || '';
            value += `<a href="${images}"  target="_blank"><img src="${images}" alt="" ></a>`;
            this.form.controls[field.slice(0, -7)]
              .get('detail')
              .setValue(value);
          }

          if (field === 'description' || field === 'verifyAuth' || field === 'businessInfo') {
            switch (field) {
              case 'description' :
                this.imagesDescription = [];
                this.imagesDescription.push({url: changeParam.file.response.url});
                this.form.controls.description
                    .get('image')
                    .setValue(changeParam.file.response.url);
                this.form.get(field).updateValueAndValidity();
                break;
              case 'verifyAuth' :
                this.imagesAuth = [];
                this.imagesAuth.push({url: changeParam.file.response.url});
                this.form.controls.verifyAuth
                  .get('image')
                  .setValue(changeParam.file.response.url);
                this.form.get(field).updateValueAndValidity();
                break;
              case 'businessInfo' :
                this.imagesBusinessInfo = [];
                this.imagesBusinessInfo.push({url: changeParam.file.response.url});
                this.form.controls.businessInfo
                  .get('image')
                  .setValue(changeParam.file.response.url);
                this.form.get(field).updateValueAndValidity();
                break;
            }

            const value = this.form.get(field).value.detail || '';
            this.form.controls[field]
              .get('detail')
              .setValue(value);
            // if (this.imagesDescription.length === 1) {
            //   this.form.controls[field]
            //     .get('image')
            //     .setValue(this.imagesDescription.map(z => z.url)[0]);
            //   this.form.get(field).updateValueAndValidity();
            // }
          }
          if (field === 'avatar') {
            this.avatar = [{url: changeParam.file.response.url}];
            this.avatarId = changeParam.file.response.url;
            this.validAvatar = false;
            // console.log(this.images);
            if (this.images.length === 0) {
              this.images.push({url: changeParam.file.response.url});
              this.images2.push(changeParam.file.response.url);
              this.form
                .get('images')
                .setValue(this.images2.map((image) => image));
            }
          }
          if (field === 'vid') {
            const _tmpUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              changeParam.file.response.url
            );
            this.videoIntro.push(_tmpUrl);
            const urlVideos = this.videoIntro.map(
              (gg) => gg.changingThisBreaksApplicationSecurity
            );

            if (this.videoIntro && this.videoIntro.length) {
              this.form.get('videos').setValue(urlVideos);
            }
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  openUploadDialogChild(field: string, arrayImages: any, controlName: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';
    const modal = this.modal.create({
      nzTitle: `Tải ảnh lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple: false,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          if (field === 'images') {
            arrayImages[0] = {url: changeParam.file.response.url};
            this.form.controls[controlName]
              .get('image')
              .setValue(changeParam.file.response.url);
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  openUploadDialogVid() {
    const fileType = 'mp4';
    const modal = this.modal.create({
      nzTitle: `Tải Video lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          const _tmpUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            changeParam.file.response.url
          );
          this.videoIntro.push(_tmpUrl);
          const urlVideos = this.videoIntro.map(
            (gg) => gg.changingThisBreaksApplicationSecurity
          );
          if (this.videoIntro && this.videoIntro.length) {
            this.form.get('videos').setValue(urlVideos);
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  onRemoveFile(field: string, index: number,) {
    if (field === 'images') {
      this.images.splice(index, 1);
      this.images2.splice(index, 1);
      this.form.get('images').setValue(this.images2);
      this.form.get(field).updateValueAndValidity();
    }
    if (field === 'avatar') {
      // console.log(this.images2, this.avatarId, 1);
      if (this.images2.length === 1 && this.images2[0] === this.avatarId) {
        this.images = [];
        this.images2 = [];
        this.form.get('images').setValue([]);
      }
      this.avatarId = undefined;
      this.avatar = [];
      this.validAvatar = false;
    }
    if (field === 'description') {
      this.imagesDescription.splice(index, 1);
      this.form.controls[field].get('image').setValue('');
    }
    if (field === 'verifyAuth') {
      this.imagesAuth.splice(index, 1);
      this.form.controls[field].get('image').setValue('');
    }
    if (field === 'businessInfo') {
      this.imagesBusinessInfo.splice(index, 1);
      this.form.controls[field].get('image').setValue('');
    }

  }

  onRemoveFileChild(
    field: string,
    index: number,
    arrayImages: any,
    controlName: string
  ) {
    if (field === 'images') {
      arrayImages.splice(index, 1);
      this.form.controls[controlName].get('image').setValue('');
    }
  }

  clearVideoUrl(index: number) {
    this.videoIntro.splice(index, 1);
    const urlVideos = this.videoIntro.map(
      (gg) => gg.changingThisBreaksApplicationSecurity
    );
    this.form.get('videos').setValue(urlVideos);
  }

  getAttibuteCategory(event) {
    console.log('event', event);
    this.form.get('categories').setValue(event);
    if (event.length === 0) {
      this.isRequired = true;
    } else {
      this.isRequired = false;
    }
  }

  regexValue(val) {
    val = val.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
    return val;
  }

  onSubmit() {
    recursiveForm(this.form);
    if (this.form.invalid) {
      // this.isRequired = true;
      // return;
    }
    if (
      !this.form.value.categories || this.form.value.categories.length === 0
    ) {
      this.isRequired = true;
      this.openMessage('error', 'Lỗi !!!', `Danh mục không được để trống`);
      this.isLoadingBtn = false;
      return;
    }

    const newForm = {...this.form.value};

    if ($('.businessInfo1 .note-editable').text().trim().length === 0) {
      if (
        this.form.get('businessInfo.detail').value &&
        this.form.get('businessInfo.detail').value.indexOf('img') === -1
      ) {
        newForm.businessInfo.detail = null;
      }
    }

    if ($('.verifyAuth1 .note-editable').text().trim().length === 0) {
      if (
        this.form.get('verifyAuth.detail').value &&
        this.form.get('verifyAuth.detail').value.indexOf('img') === -1
      ) {
        newForm.verifyAuth.detail = null;
      }
    }

    if ($('.description1 .note-editable').text().trim().length === 0) {
      if (
        this.form.get('description.detail').value &&
        this.form.get('description.detail').value.indexOf('img') === -1
      ) {
        newForm.description.detail = null;
      }
    }

    newForm.mainImage = this.avatarId || '';
    this.validAvatar = false;

    if (newForm.images && newForm.images.length > 0 && !newForm.mainImage) {
      this.validAvatar = true;
      this.openMessage('warning', 'Cảnh báo', `Vui lòng cập nhật ảnh đại diện`);
      return;
    }
    if (!newForm.images && newForm.mainImage) {
      newForm.images = [newForm.mainImage]
    }

    if (newForm.mainImage && newForm.images && newForm.images.length === 0) {
      this.openMessage('warning', 'Cảnh báo', `Vui lòng cập nhật ảnh sản phẩm`);
      return;
    }
    newForm.productName = capitalizeFirstLetter(
      removeAllSpacingBetweenWords(this.form.value.productName)
    );
    if (newForm.color) {
      newForm.color = newForm.color.trim();
    }
    if (newForm.description.description && newForm.description.description.length > 255) {
      this.openMessage('warning', 'Cảnh báo', `Mô tả ngắn sản phẩm vượt quá 255 ký tự`);
      return;
    }

    if (newForm.businessInfo.description && newForm.businessInfo.description.length > 255) {
      this.openMessage('warning', 'Cảnh báo', `Mô tả ngắn giới thiệu vượt quá 255 ký tự`);
      return;
    }

    if (newForm.verifyAuth.description && newForm.verifyAuth.description.length > 255) {
      this.openMessage('warning', 'Cảnh báo', `Mô tả ngắn phân biệt thật giả vượt quá 255 ký tự`);
      return;
    }

    if (newForm.description.description) {
      newForm.description.description = newForm.description.description.trim();
    }


    if (newForm.description.detail) {
      newForm.description.detail = newForm.description.detail.trim();
    }

    if (newForm.businessInfo.detail) {
      newForm.businessInfo.detail = newForm.businessInfo.detail.trim();
    }

    if (newForm.businessInfo.description) {
      newForm.businessInfo.description = newForm.businessInfo.description.trim();
    }


    if (newForm.verifyAuth.detail) {
      newForm.verifyAuth.detail = newForm.verifyAuth.detail.trim();
    }

    if (newForm.verifyAuth.description) {
      newForm.verifyAuth.description = newForm.verifyAuth.description.trim();
    }

    const ecommerceList = this.ecommerceList.map(z => {
      return {id: z.defaultEcommerce.key, price: z.price, link: z.link, promotion_price: z.promotion_price};
    });

    const checkEcommerce = ecommerceList.some(z => {
      console.log(z.id);
      return z.id === 0;
    });
    const checklink = ecommerceList.some(z => {
      return !z.link || !z.link.startsWith('http://') && !z.link.startsWith('https://');
    });
    const linkEmpty = ecommerceList.some(z => !z.link)
    if (checkEcommerce || linkEmpty) {
      this.openMessage('warning', 'Cảnh báo', `Chưa điền thông tin sàn thương mại điện tử`);
      return;
    }

    if (checklink) {
      this.openMessage('warning', 'Cảnh báo', `Link sàn thương mại không đúng định dạng`);
      return;
    }

    console.log('newForm', newForm);
    const valueSavedb = {...newForm, ecommerceList};

    this.isLoadingBtn = true;
    this.productService
      .update(this.productId, valueSavedb)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.code === 1) {
          this.openMessage('success', 'Thành công', 'Cập nhật thành công');
          let delayTimer: any;
          clearTimeout(delayTimer);
          this.delayTimer = setTimeout(() => {
            this.isLoadingBtn = false;
            this.router.navigate(['/business/products']);
            return;
          }, 1500);
        }
        if (res.code !== 1) {
          this.openMessage('warning', 'Cảnh báo', `${res.message}`);
          this.isLoadingBtn = false;
        }
      }),
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
        this.isLoadingBtn = false;
      };
  }

  back() {

    this.router.navigate(['/business/products']);
  }

  moveScroll(idTab: string, direction: string = 'plus' || 'minus') {
    const element = document.querySelector(`.${idTab}`);
    const left = element.scrollLeft;
    direction === 'plus' ? element.scroll({left: left + 200, behavior: 'smooth'}) :
      element.scroll({left: left - 200, behavior: 'smooth'});

  }

  deleteListImage(index) {
    this.images2.splice(index, 1);
    this.images.splice(index, 1);
    this.form.get('images').setValue(this.images2);
  }

  readMore(videoIntro?) {
    console.log(videoIntro);
    const modal = this.modal.create({
        nzContent: ReadMoreFileComponent,
        nzFooter: null,
        nzWidth: '1035px',
        nzBodyStyle: {
          background: 'transparent !important',
        },
        nzClosable: false,
        nzComponentParams: {
          files: videoIntro || this.images,
          type: (videoIntro && 'video') || 'images'
        }
      }
    );

    modal.afterClose.subscribe((z: any) => {
      console.log(modal.getContentComponent().urls);
      if (!videoIntro) {
        this.images = modal.getContentComponent().urls.map(q => {
          return {url: q};
        });
        this.form.get('images').setValue(this.images.map(z => z.url));
      } else {
        this.form.get('videos').setValue(modal.getContentComponent().urls);
        this.videoIntro = modal.getContentComponent().urls.map(z => this.sanitizer.bypassSecurityTrustResourceUrl(z));

      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    localStorage.removeItem('history_item');
    this.unsubscribe$.complete();
  }
}
